<template>
  <div>
    <div class="all conent">
      <div class="tabs">
        <div class="tab-item tab-item-active">物品领用清单</div>
      </div>
      <div>
        <el-form :inline="true"
                 :model="dataForm"
                 @keyup.enter.native="getDataList(1)"
                 @submit.native.prevent
                 label-width="100px">
          <div class="search-row">
            <div class="search-conent">
              <el-form-item label="领用单号：">
                <el-input v-model="dataForm.receiveCode"
                          placeholder="领用单号"
                          clearable></el-input>
              </el-form-item>
            </div>
            <div class="search-conent">
              <el-form-item label="备件名称：">
                <el-input v-model="dataForm.goodsName"
                          placeholder="备件名称"
                          clearable></el-input>
              </el-form-item>
            </div>
            <div class="search-but">
              <button class="info-but"
                      @click="getDataList(1)">查询</button>
            </div>
          </div>
          <div class="search-row">
            <div class="search-conent">
              <el-form-item label="领用日期：">
                <el-date-picker v-model="dataForm.dateValue"
                                type="daterange"
                                align="left"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format='yyyy-MM-dd'
                                style="width:240px;"
                                :disabled="dataForm.dateValue3 ? true : false"></el-date-picker>
              </el-form-item>
            </div>
            <div class="search-conent">
              <el-form-item>
                <!-- <el-checkbox-group v-model="dataForm.dateValue2" :max="1" :disabled="Boolean(dataForm.dateValue)">
          <el-checkbox v-for="data in dateOptions" :label="data.code" :key="data.code">{{data.value}}</el-checkbox>
      </el-checkbox-group> -->
                <!-- <el-radio-group v-model="dataForm.dateValue3">
        <el-radio @click.native.prevent="clickItem(data.value)" v-for="data in dateOptions" :label="data.code" :key="data.code">{{data.value}}</el-radio>
      </el-radio-group> -->
                <el-radio-group v-model="dataForm.dateValue3"
                                :disabled="Boolean(dataForm.dateValue)">
                  <el-radio v-for="data in dateOptions"
                            :label="data.value"
                            :key="data.code"
                            @click.native.stop="(e) => clickItem(e,data.value)">{{data.value}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="search-but">
              <button class="info-but"
                      @click="reset()">重置</button>
            </div>
          </div>
        </el-form>
      </div>
      <el-table :data="dataList"
                border
                @selection-change="selectionChangeHandle">
        <el-table-column type="index"
                         width="50"
                         label="序号"></el-table-column>
        <el-table-column prop="oldGoodsCode"
                         header-align="center"
                         align="left"
                         label="物品编码"
                         width="100"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="receiveCode"
                         header-align="center"
                         align="left"
                         label="领用单号"
                         width="190"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="oldGoodsName"
                         header-align="center"
                         align="left"
                         label="物品名称"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="oldSpecification"
                         header-align="center"
                         align="left"
                         label="规格"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="oldModel"
                         header-align="center"
                         align="left"
                         label="型号"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="oldEdition"
                         header-align="center"
                         align="left"
                         label="版本"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="oldConfiguration"
                         header-align="center"
                         align="left"
                         label="配置"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="oldBrand"
                         header-align="center"
                         align="left"
                         label="品牌"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="price"
                         header-align="center"
                         align="left"
                         label="单价"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="oldRemark"
                         header-align="center"
                         align="left"
                         label="备注"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="receiveQuantity"
                         header-align="center"
                         align="right"
                         label="领用数量"
                         width="90"
                         show-overflow-tooltip></el-table-column>
      </el-table>
      <div class="doclist-pagination"
           v-if="dataList.length">
        <div class="doclist-lastpage"
             @click="jumpLastPage">上一页</div>
        <div class="doclist-omit">{{lastOmit}}</div>
        <ul>
          <li :class="item === currentPage?'pageactive':''"
              v-for="item in pageList"
              :key="item"
              @click="changePageTo(item)">{{item}}</li>
        </ul>
        <div class="doclist-omit">{{nextOmit}}</div>
        <div class="doclist-nextpage"
             @click="jumpNextPage">下一页</div>
        <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text"
                 v-model.number="jumpTargetPage">页</div>
        <div class="doclist-jump"
             @click="jumpFarPage">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      selectList: [],
      dataForm: {
        receiveCode: '',
        goodsName: '',
        dateValue: null,
        dateValue2: [],
        dateValue3: ''
      },
      dateOptions: [
        { code: '0', value: '1个月' },
        { code: '1', value: '3个月' },
        { code: '2', value: '半年' },
        { code: '3', value: '一年' }
      ],
      dataList: [],
      // 分页
      currentPage: 1, // 当前页
      pageSize: 10,
      totalPage: 4, // 总页数
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1 // 跳转页
      // pickerOptions: {
      //   disabledDate(time) {
      //     return time.getTime() >= (Date.now())
      //   }
      // }
    }
  },
  methods: {
    clickItem (e, value) {
      e.preventDefault()
      value === this.dataForm.dateValue3
        ? (this.dataForm.dateValue3 = '')
        : (this.dataForm.dateValue3 = value)
    },
    // 多选
    selectionChangeHandle (list) {
      this.selectList = list
    },
    routerHandle (routerName) {
      this.$router.push(routerName)
    },
    // 上一页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    //  下一页
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    //   第几页
    changePageTo (page) {
      this.getDataList(page)
    },
    //   确定跳转到哪页
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        this.changePageTo(this.jumpTargetPage)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    getDataList (currentPage = this.currentPage) {
      var timeTag
      if (this.dataForm.dateValue3 === '1个月') {
        timeTag = '0'
      } else if (this.dataForm.dateValue3 === '3个月') {
        timeTag = '1'
      } else if (this.dataForm.dateValue3 === '半年') {
        timeTag = '2'
      } else if (this.dataForm.dateValue3 === '一年') {
        timeTag = '3'
      } else {
        timeTag = ''
      }
      // var timeTag = this.dataForm.dateValue3
      this.$http
        .get(`${window.SITE_CONFIG['baseURL']}/lclb/receive/receiveList`, {
          params: {
            page: currentPage,
            limit: this.pageSize,
            receiveCode: this.dataForm.receiveCode,
            oldGoodsName: this.dataForm.goodsName,
            startDate: this.dataForm.dateValue
              ? this.dataForm.dateValue[0]
              : '',
            endDate: this.dataForm.dateValue ? this.dataForm.dateValue[1] : '',
            timeTag: this.dataForm.dateValue ? '' : timeTag
          }
        })
        .then((data) => {
          if (data && data.result && data.result.code === 0) {
            this.dataList = data.result.data.data || []
            this.totalPage = Math.ceil(data.result.data.count / 10)
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.setPageTo(currentPage)
        })
        .catch(() => {
          this.dataList = []
        })
    },
    setPageTo (page) {
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [
            this.totalPage - 4,
            this.totalPage - 3,
            this.totalPage - 2,
            this.totalPage - 1,
            this.totalPage
          ]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
    },
    // 清空form
    reset () {
      this.dataForm = {
        receiveCode: '',
        dateValue: null,
        dateValue2: [],
        goodsName: '',
        dateValue3: ''
      }
      this.getDataList(1)
    }
  },
  mounted () {
    if (this.$route.query.goodsName) {
      this.dataForm.goodsName = this.$route.query.goodsName
    }
    this.getDataList()
  }
}
</script>
<style scoped>
.conent {
  width: 970px;
  padding: 20px 20px;
}
.search-row {
  display: flex;
}
.search-conent {
  min-width: 350px;
  margin-right: 20px;
}
.search-but {
  width: 100%;
  min-width: 200px;
  text-align: right;
}
.opt-row {
  width: 100%;
  display: flex;
  text-align: right;
  margin-bottom: 20px;
}
.opt-right {
  width: 300px;
}
.opt-left {
  width: 100%;
  text-align: left;
}
.info-but {
  background: #ffffff;
  width: 96px;
  height: 40px;
  text-align: center;
  line-height: 38px;
  font-size: 14px;
  color: #1d65a8;
  letter-spacing: 0;
  border: none;
  cursor: pointer;
  user-select: none;
  border: 1px solid #1d65a8;
  margin-right: 10px;
}
.info-but:hover {
  background: #1d65a8;
  color: #ffffff;
}
.info-but-new {
  background: #1d65a8;
  color: #ffffff;
}
.but-file {
  background-color: #ffffff;
  border: none;
}
.demand-desc {
  width: 100%;
  cursor: pointer;
}
.tip {
  max-width: 500px;
  word-wrap: break-word;
  word-break: break-all;
}
.red {
  color: red;
}
.detail-icon {
  cursor: pointer;
}
.detail-icon:hover {
  color: #1d65a8;
}
.tooltip-content {
  width: 60px;
  text-align: center;
  border-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.short-content {
  max-height: 69px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
